import { SET_CURRICULAS } from "../actions/curriculaActions";

interface CurriculaReducerState {
    curriculas: any
}

const initialState: CurriculaReducerState = {
    curriculas : undefined 
 }

const curriculaReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_CURRICULAS:
            return {
                ...state,
                curriculas: action.value
            }
        default:
            return state;
    }
}



export default curriculaReducer;